import { ResponseHelper } from '../_helpers/response.helper'
import axiosInstance from './axios.service'

export class BannerService {
  private setError: (message: string | null) => void

  constructor (setError: (message: string | null) => void) {
    this.setError = setError
  }


  async getCurrentBanner () {
    return axiosInstance
      .get('/banner')
      .then(res => res.data.data)
      .catch(e => ResponseHelper.handleError(e, this.setError))
  }
}
